import { render, staticRenderFns } from "./cheapest-taxi-service-goa.vue?vue&type=template&id=34a9919c&scoped=true"
import script from "./cheapest-taxi-service-goa.vue?vue&type=script&lang=js"
export * from "./cheapest-taxi-service-goa.vue?vue&type=script&lang=js"
import style0 from "./cheapest-taxi-service-goa.vue?vue&type=style&index=0&id=34a9919c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a9919c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TaxiCard: require('/workspace/components/TaxiCard.vue').default,FaqCard: require('/workspace/components/FaqCard.vue').default})
